//@flow
import { Formik } from 'formik';
import _ from 'lodash';
import * as React from 'react';
import 'react-confirm-alert/src/react-confirm-alert.css';
import connect from 'react-redux/es/connect/connect';
import * as Yup from 'yup';
import FormSelectInput from '../../components/Inputs/FormSelectInput';
import SelectInput from '../../components/Inputs/SelectInput';
import Toast from '../../components/Toasts/Toast';
import { objectsConstants } from '../../constants/objects.constants';
import { formatterHelper } from '../../helpers/formatter.helper';
import { isSudo } from '../../helpers/permissions.helper';
import { clienteService } from '../../services/cliente.service';
import { defaultService } from '../../services/defaultService';
import { mapaProdutosService } from '../../services/mapaProdutos.service';
import { pontoAtendimentoService } from '../../services/pontoAtendimento.service';
import { produtoService } from '../../services/produto.service';
import { userService } from '../../services/user.service';
import TopoTitleComponente from '../Topo/TopoTitleComponente';
import { confirmAlert } from 'react-confirm-alert';
import FormInput from '../../components/Inputs/FormInput';

const validationSchema = Yup.object().shape({
  pontoAtendimentoId: Yup.string().required(
    'Ponto de Atendimento é obrigatório'
  ),
  ativo: Yup.boolean().required(),
  produtos: Yup.array()
    .min(1, 'Deve haver ao menos 1 produto no mapa')
    .of(
      Yup.object().shape({
        idProduto: Yup.string()
          .nullable()
          .required('Produto obrigatório'),
        limiteMaximo: Yup.number()
          .typeError('Limite deve ser um número')
          .min(1, 'Mínimo 1')
          .required('Obrigatório'),
      })
    )
    .test('produtos-unicos', 'Produto duplicado', (produtos) => {
      const ids = (produtos || []).map((p) => p.idProduto || null);
      const semNulos = ids.filter((id) => id !== null);
      return new Set(semNulos).size === semNulos.length;
    }),
});

class MapaProdutosEdit extends React.PureComponent<Props> {
  constructor(props) {
    super(props);
    const user = userService.getCurrentUser();
    this.state = {
      entity: {
        produtos: [],
        cliente: isSudo() ? null : user.cliente,
        ativo: true,
        atualizou: false,
      },
    };
  }

  componentDidMount() {
    this.carregarDadosIniciais();
  }

  carregarDadosIniciais = async () => {
    this.props.loading(true);

    try {
      const id = _.get(this.props.match, 'params.id');
      const user = userService.getCurrentUser();
      const clientePadrao = isSudo() ? null : user.cliente;

      if (id) {
        const response = await mapaProdutosService.doGet(id);
        const mapa = response.data;

        mapa.produtos = (mapa.produtos || []).map((item) => ({
          produto: item.produto,
          idProduto: (item.produto && item.produto.id) || item.idProduto,
          limiteMaximo: item.limiteMaximo,
        }));

        const cliente = isSudo() ? mapa.cliente : user.cliente;

        const respProdutos = await produtoService.findAll(cliente);

        this.setState(
          {
            entity: {
              ...mapa,
              cliente: cliente,
            },
            todosProdutos: respProdutos.data,
            atualizou: true,
          },
          () => this.props.loading(false)
        );
      } else if (clientePadrao) {
        const resp = await produtoService.findAll(clientePadrao);
        this.setState(
          {
            todosProdutos: resp.data,
            entity: {
              ...this.state.entity,
              cliente: clientePadrao,
            },
            atualizou: true,
          },
          () => this.props.loading(false)
        );
      } else {
        this.setState({ atualizou: true }, () => this.props.loading(false));
      }
    } catch (error) {
      console.error('Erro ao carregar dados iniciais', error);
      this.props.loading(false);
    }
  };

  filterProdutosDisponiveis = (todosProdutos, valores, indexAtual) => {
    const idsSelecionados = (valores.produtos || [])
      .map((p, index) =>
        index !== indexAtual
          ? p.idProduto || (p.produto && p.produto.id) || null
          : null
      )
      .filter((id) => id !== null && id !== undefined);

    return todosProdutos.filter((p) => !idsSelecionados.includes(p.id));
  };

  render() {
    const { entity, atualizou } = this.state;
    const isEdit = !!this.state.entity.id;

    const dadosCarregados = !!atualizou;

    return (
      <React.Fragment>
        <TopoTitleComponente
          mainTitle="Mapa de Produtos"
          subTitle=" "
          canBack={true}
        />
        <Formik
          validationSchema={validationSchema}
          validateOnBlur={false}
          validateOnChange={false}
          initialValues={entity}
          enableReinitialize={true}
          onSubmit={(values, actions) => {
            this.props.loading(true);
            const entidade = _.cloneDeep(values);
            if (_.get(entidade, '_links.self.href')) {
              _.set(
                entidade,
                'id',
                defaultService.getIdFromUrl(_.get(entidade, '_links.self.href'))
              );
            }
            if (!isSudo()) {
              entidade.cliente = userService.getCurrentUser().cliente;
            }
            mapaProdutosService
              .doSave(entidade)
              .then(() => {
                actions.setSubmitting(false);
                this.props.loading(false);
                this.props.success({
                  message: 'Mapa de Produtos salvo com sucesso.',
                });
                this.props.history.push('/mapaProdutos');
              })
              .catch((e) => {
                console.error(e);
                this.props.loading(false);
                actions.setSubmitting(false);
              });
          }}
        >
          {({
            values,
            errors,
            touched,
            handleChange,
            handleSubmit,
            isSubmitting,
            setFieldValue,
          }) => {
            console.log('Erros de validação', errors);
            console.log('Produtos atuais', values.produtos);

            return (
              <form onSubmit={handleSubmit} noValidate>
                <div className="flex-column">
                  <Toast />
                  <div className="cardSeculus d-flex flex-column mb-0">
                    <div className="form-row">
                      {isSudo() && (
                        <div className="form-group col-md-6">
                          <FormSelectInput
                            name="cliente"
                            id="cliente"
                            label="Cliente"
                            placeholder="Selecione o cliente"
                            valueKey="codigoCliente"
                            labelKey="label"
                            required={true}
                            returnFullObject={true}
                            service={clienteService.findAll}
                            onChange={(name, value) =>
                              setFieldValue(name, value)
                            }
                            value={values.cliente}
                            messageValidate={touched.cliente && errors.cliente}
                          />
                        </div>
                      )}
                      {values.cliente && dadosCarregados && (
                        <div className="form-group col-md-6">
                          <FormSelectInput
                            key={
                              (values.cliente &&
                                values.cliente.codigoCliente) ||
                              'pontoAtendimento'
                            }
                            name="pontoAtendimentoId"
                            id="pontoAtendimentoId"
                            label="Ponto de Atendimento"
                            placeholder="Selecione o PA"
                            valueKey="id"
                            labelKey="nome"
                            required={true}
                            returnFullObject={false}
                            parent={values.cliente}
                            disabled={!values.cliente}
                            service={(cliente) =>
                              isEdit
                                ? pontoAtendimentoService.findAllByCliente(
                                    cliente
                                  )
                                : pontoAtendimentoService.findAllSemMapa(
                                    cliente
                                  )
                            }
                            onChange={(name, value) =>
                              setFieldValue(name, value)
                            }
                            value={values.pontoAtendimentoId}
                            messageValidate={_.get(
                              errors,
                              'pontoAtendimentoId'
                            )}
                          />
                        </div>
                      )}
                      <div className="form-group col-md-6">
                        <SelectInput
                          id={'ativo'}
                          options={[
                            { label: 'Sim', value: true },
                            { label: 'Não', value: false },
                          ]}
                          noSize
                          returnFullObject={true}
                          label="Este mapa de produtos está ativo? "
                          required={true}
                          labelKey={'label'}
                          valueKey={'value'}
                          name={'ativo'}
                          defaultValue={
                            values.ativo && values.ativo.value === false
                              ? 'Não'
                              : formatterHelper.getLabelEnum(
                                  values.ativo && values.ativo.value
                                    ? values.ativo.value
                                    : values.ativo
                                    ? values.ativo
                                    : false,
                                  objectsConstants.SIM_NAO
                                )
                          }
                          value={
                            _.isBoolean(values.ativo)
                              ? formatterHelper.getEnum(
                                  values.ativo,
                                  objectsConstants.SIM_NAO
                                )
                              : values.ativo
                          }
                          onChange={(name, value) => {
                            setFieldValue(name, value.value);
                          }}
                        />
                      </div>

                      <div className="form-group col-12 mt-3">
                        <h2>Produtos do Mapa</h2>
                      </div>

                      {values.produtos.map((item, index) => (
                        <React.Fragment key={index}>
                          <div className="form-group col-md-8">
                            <SelectInput
                              name={`produtos[${index}].produto`}
                              id={`produto-${index}`}
                              label="Descrição do Produto"
                              placeholder="Selecione o produto"
                              valueKey="id"
                              labelKey="label"
                              parent={values.cliente}
                              disabled={!values.cliente}
                              noSize={true}
                              returnFullObject={true}
                              options={this.filterProdutosDisponiveis(
                                this.state.todosProdutos || [],
                                values,
                                index
                              )}
                              onChange={(name, value) => {
                                setFieldValue(
                                  `produtos[${index}].produto`,
                                  value
                                );
                                setFieldValue(
                                  `produtos[${index}].idProduto`,
                                  value && value.id
                                );
                              }}
                              value={
                                item.produto ||
                                (item.idProduto
                                  ? { id: item.idProduto, descricao: '' }
                                  : null)
                              }
                              messageValidate={_.get(
                                errors,
                                `produtos[${index}].idProduto`
                              )}
                            />
                          </div>

                          <div className="form-group col-md-2">
                            <FormInput
                              label="Limite Máximo"
                              type="number"
                              id={`produtos${index}limiteMaximo`}
                              messageValidate={_.get(
                                errors,
                                `produtos[${index}].limiteMaximo`
                              )}
                              name={`produtos[${index}].limiteMaximo`}
                              value={item.limiteMaximo}
                              onChange={setFieldValue}
                            />
                          </div>

                          <div className="form-group col-md-2 d-flex align-items-center">
                            <button
                              type="button"
                              className="btn btn-danger btn-sm"
                              onClick={() => {
                                const novaLista = values.produtos.filter(
                                  (_, i) => i !== index
                                );
                                setFieldValue('produtos', novaLista);
                              }}
                            >
                              Remover
                            </button>
                          </div>
                        </React.Fragment>
                      ))}

                      <div className="form-group col-12 text-left">
                        <button
                          type="button"
                          className="btn btn-secondary btn30 green"
                          onClick={() => {
                            const novo = { idProduto: null, limiteMaximo: 0 };
                            setFieldValue('produtos', [
                              ...values.produtos,
                              novo,
                            ]);
                          }}
                        >
                          + Adicionar Produto
                        </button>
                      </div>
                    </div>

                    <div
                      style={{
                        borderBottom: '1px solid #ccc',
                        margin: '2rem 0',
                      }}
                    />

                    <div className="d-flex flex-row flex-sm-row ">
                      <div className="col-6 col-lg text-center p-0 mt-lg-2 mb-1">
                        <button
                          type="button"
                          className="btn btn-secondary btn30 white"
                          disabled={isSubmitting}
                          onClick={() => this.props.history.goBack()}
                        >
                          Cancelar
                        </button>
                      </div>
                      {isEdit && (
                        <div className="col-6 col-lg text-center p-0 mt-lg-2 mb-1">
                          <button
                            type="button"
                            className="btn btn-danger btn30"
                            disabled={isSubmitting}
                            onClick={() => {
                              confirmAlert({
                                customUI: ({ onClose }) => (
                                  <div className="custom-confirm-alert">
                                    <h2>Confirmar exclusão</h2>
                                    <p>
                                      Você tem certeza que deseja excluir este
                                      Ponto de Atendimento?
                                    </p>
                                    <div className="d-flex justify-content-around mt-4">
                                      <button
                                        className="btn btn-secondary btn30 white"
                                        onClick={onClose}
                                      >
                                        Não
                                      </button>
                                      <button
                                        className="btn btn-danger btn30"
                                        onClick={async () => {
                                          try {
                                            await mapaProdutosService.doDelete(
                                              values.id
                                            );
                                            this.props.success({
                                              message:
                                                'Ponto de Atendimento excluído com sucesso.',
                                            });
                                            this.props.history.push(
                                              '/mapaProdutos'
                                            );
                                            onClose();
                                          } catch (e) {
                                            console.error(e);
                                            this.props.error({
                                              message:
                                                'Erro ao excluir o Ponto de Atendimento.',
                                            });
                                            onClose();
                                          }
                                        }}
                                      >
                                        Sim
                                      </button>
                                    </div>
                                  </div>
                                ),
                              });
                            }}
                          >
                            Excluir
                          </button>
                        </div>
                      )}

                      <div className="col-6 col-lg text-center p-0 mt-lg-2 mb-1">
                        <button
                          type="submit"
                          className="btn btn-secondary btn30 green"
                          disabled={
                            isSubmitting || values.produtos.length === 0
                          }
                        >
                          {isEdit ? 'Salvar Alterações' : 'Salvar'}
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </form>
            );
          }}
        </Formik>
      </React.Fragment>
    );
  }
}

function mapStateToProps(state) {
  const { user } = state.authentication;
  return { user };
}

const mapDispatch = ({
  alert: { success, error, clear },
  load: { loading },
}) => ({
  success: (msg) => success(msg),
  loading: (load: boolean) => loading({ load }),
  error: (msg) => error(msg),
  clear: () => clear(),
});

export default connect(
  mapStateToProps,
  mapDispatch,
  null,
  { forwardRef: true }
)(MapaProdutosEdit);
